import { useState, useEffect } from "react"
import axiosAuth from "../../helpers/axios_auth"
import { useSelector } from "react-redux"
import { loginData } from "../../stores/auth"
import swal from "sweetalert"
import { errorHandling } from "../../helpers"

const useSatkerPimpinan = () => {
    const dataLogin = useSelector(loginData)

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const [selectedRows, setSelectedRows] = useState([])

    // 🔹 TOP FILTER SATKER
    const [filterSatker, setFilterSatker] = useState(null)
    const [satkerPimpinanOptions, setSatkerPimpinanOptions] = useState([])

    // 🔹 MODAL SATKER ASSIGNMENT (old logic)
    const [allSatkerOptions, setAllSatkerOptions] = useState([])
    const [selectedSatker, setSelectedSatker] = useState([])

    const [isSubmit, setIsSubmit] = useState(false)

    const [satkerSearch, setSatkerSearch] = useState("")

    // ================= FETCH SATKER FOR FILTER =================
    const getSatkerPimpinan = async (keyword = "") => {
        try {
            const res = await axiosAuth.get(`/v1/satker`, {
                params: { keyword },
                headers: { Authorization: `Bearer ${dataLogin.token_account}` },
            })

            if (res.data.status_code === 200) {
                const satkerList = Array.isArray(res?.data?.data?.rows) ? res.data.data.rows : []

                setSatkerPimpinanOptions(
                    satkerList.map(s => ({
                        value: s.kode_satuan_kerja,
                        label: s.satuan_kerja,
                    }))
                )

            }
        } catch (err) {
            swal("Error", errorHandling(err), "error")
        }
    }

    // ================= FETCH PEGAWAI BY SATKER =================
    const fetchUsersBySatker = async (satkerKode) => {
        // if (!satkerKode) return
        setLoading(true)
        try {
            const res = satkerKode ? await axiosAuth.get(`/v1/users`, {
                params: {
                    is_admin: false,
                    kode_satker_pimpinan: satkerKode,
                },
                headers: { Authorization: `Bearer ${dataLogin.token_account}` },
            }) :
                await axiosAuth.get(`/v1/users`, {
                    params: {
                        is_admin: false,
                    },
                    headers: { Authorization: `Bearer ${dataLogin.token_account}` },
                })

            if (res.data.status_code === 200) {
                setData(res.data.data.rows ?? [])
            }
        } catch (err) {
            swal("Error", errorHandling(err), "error")
        } finally {
            setLoading(false)
        }
    }

    // ================= FETCH SATKER (OLD MODAL) =================
    const getAllSatker = async (keyword = "") => {
        try {
            const response = await axiosAuth.get(`/v1/satker`, {
                params: { keyword },
                headers: { Authorization: `Bearer ${dataLogin.token_account}` },
            })

            if (response.data.status_code === 200) {
                const satkerList = Array.isArray(response?.data?.data?.rows) ? response.data.data.rows : []

                setAllSatkerOptions(
                    satkerList.map(s => ({
                        value: s.kode_satuan_kerja,
                        label: s.satuan_kerja,
                    }))
                )

            }
        } catch (err) {
            swal("Error", errorHandling(err), "error")
        }
    }

    // const handleRowSelected = (state) => {
    //     setSelectedRows(state.selectedRows)
    // }

    const handleRowSelected = (state) => {
        const user = state.selectedRows[0]
        setSelectedRows(state.selectedRows)

        if (user?.list_satker_pimpinan) {
            setSelectedSatker(
                user.list_satker_pimpinan.map(s => ({
                    value: s.kode_satuan_kerja,
                    label: s.satuan_kerja
                }))
            )
        }
    }

    // ================= SUBMIT UPDATE =================
    const handleSubmitSatker = async (e) => {
        e.preventDefault()
        if (!selectedRows.length) return swal("Pilih pegawai dulu", "", "warning")
        if (!selectedSatker.length) return swal("Pilih minimal 1 satker", "", "warning")

        setIsSubmit(true)
        try {
            await axiosAuth.put(
                `/v1/admin/users/update-satker-pimpinan`,
                {
                    user_id: selectedRows[0].id,
                    satker_ids: selectedSatker.map((s) => s.value),
                },
                { headers: { Authorization: `Bearer ${dataLogin.token_account}` } }
            )

            // swal("Berhasil", "Satker berhasil diperbarui", "success")
            swal("Berhasil", "Satker berhasil diperbarui", "success").then(() => {
                const modalEl = document.getElementById("satkerModal")
                const modal = window.bootstrap.Modal.getInstance(modalEl)
                modal?.hide()
            })


            fetchUsersBySatker(filterSatker)
            // getSatkerPimpinan()
            // getAllSatker()
            setSelectedSatker([])
        } catch (err) {
            swal("Error", errorHandling(err), "error")
        } finally {
            setIsSubmit(false)
        }
    }

    useEffect(() => {
        fetchUsersBySatker()
        getSatkerPimpinan()
        getAllSatker()
    }, [])

    return {
        data,
        loading,
        selectedRows,
        satkerPimpinanOptions,
        filterSatker,
        setFilterSatker,
        fetchUsersBySatker,
        allSatkerOptions,
        selectedSatker,
        isSubmit,
        handleRowSelected,
        handleSubmitSatker,
        setSelectedSatker,
        getSatkerPimpinan,
        getAllSatker,
        satkerSearch,        // ⭐ ADD THIS
        setSatkerSearch,
    }
}

export default useSatkerPimpinan
